<template>
  <div>
    <v-navigation-drawer
      class="hidden-md-and-up"
      v-model="drawer"
      absolute
      temporary
      width="320"
    >
      <v-list-item class="pa-5">
        <div class="logo">
          <img
            src="../../assets/images/logo/logo-symbol-dark.png"
            alt="brand-image"
          />
        </div>
        <v-spacer></v-spacer>
        <v-btn
          class="close-icon"
          icon
          @click="drawer = !drawer"
          v-html="iconSvg(closeIcon)"
        >
        </v-btn>
      </v-list-item>

      <v-list>
        <v-list-group
          v-for="item in homeVersionSidebarDropDownItems"
          :key="item.title"
          v-model="item.active"
          :ripple="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            link
            v-for="child in item.items"
            :to="child.to"
            :key="child.title"
            :ripple="false"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- End sidebar home dropdown item list -->

        <v-list-group
          v-for="item in servicesSidebarDropDownItems"
          :key="item.title"
          v-model="item.active"
          :ripple="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            link
            :ripple="false"
            v-for="child in item.items"
            :to="child.to"
            :key="child.title"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- End sidebar services dropdown item list -->

        <v-list-group
          v-for="item in pagesSidebarDropDownItems"
          :key="item.title"
          v-model="item.active"
          :ripple="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            link
            :ripple="false"
            v-for="child in item.items"
            :to="child.to"
            :key="child.title"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- End sidebar pages dropdown item list -->

        <v-list-group
          v-for="item in blocksSidebarDropDownItems"
          :key="item.title"
          v-model="item.active"
          :ripple="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            link
            :ripple="false"
            v-for="child in item.items"
            :to="child.to"
            :key="child.title"
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- End sidebar block dropdown item list -->

        <v-list-item
          :ripple="false"
          v-for="item in items"
          :key="item.title"
          :to="item.to"
          link
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- End mobile menu sidebar item list -->
      </v-list>
    </v-navigation-drawer>
    <!-- End sidebar mobile menu -->

    <v-app-bar
      dark
      elevation="0"
      color="transparent"
      absolute
      class="default-header"
    >
      <router-link to="/" class="logo">
        <slot name="logo"></slot>
      </router-link>
      <!-- End brand logo -->
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only hidden-sm-only height-auto">
        <v-btn :ripple="false" text to="/">Home</v-btn>
        <v-btn :ripple="false" text to="/service">Service</v-btn>
        <v-btn :ripple="false" text to="/about">About</v-btn>
        <v-btn :ripple="false" text to="/contact">Contact</v-btn>
      </v-toolbar-items>
      <!-- End header menu item -->
      <v-btn
        :ripple="false"
        icon
        class="ma-0 pa-0 hidden-md-and-up menu_icon"
        @click="drawer = !drawer"
        v-html="iconSvg(icon)"
      >
      </v-btn>
      <!-- End mobile menu icon -->
    </v-app-bar>
    <!-- End top header navbar -->
  </div>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data: () => ({
      drawer: false,
      items: [
        { title: "Home", to: "/" },
        { title: "Service", to: "/service" },
        { title: "About", to: "/about" },
        { title: "Contact", to: "/contact" },
      ],
      HomeVerisiondropDownItems: [
        { title: "Minimal Portfolio", to: "/minimal-portfolio" }
      ],
      ServicesdropDownItems: [
        { title: "Service", to: "/service" },
        { title: "Service Details", to: "/service-details" }
      ],
      PagesdropDownItems: [
        { title: "Blog List", to: "/blog" },
        { title: "Blog Details", to: "/blog-details" },
        { title: "Service", to: "/service" },
        { title: "Service Details", to: "/service-details" },
        { title: "Portfolio", to: "/portfolio" },
        { title: "Portfolio Details", to: "/portfolio-details" },
        { title: "404 Page", to: "/404" }
      ],
      blocksDropDownItems: [
        { title: "Portfolio", to: "/portfolio" },
        { title: "Team", to: "/team" },
        { title: "Service", to: "/service" },
        { title: "Video Popup", to: "/video-popup" },
        { title: "Progressbar", to: "/progressbar" },
        { title: "Gallery", to: "/gallery" },
        { title: "Counters", to: "/counter" },
        { title: "Blog List", to: "/blog" },
        { title: "Client Logo", to: "/brand" },
        { title: "Contact Form", to: "/contact-form" },
        { title: "Columns", to: "/column" },
        { title: "Button", to: "/button" },
        { title: "Testimonial", to: "/testimonial" },
        { title: "Pricing Plan", to: "/pricing-plan" },
        { title: "Office Location", to: "/office-location" }
      ],

      // Bellow mobile menu items
      homeVersionSidebarDropDownItems: [
        {
          items: [
            { title: "Minimal Portfolio", to: "/minimal-portfolio" }
          ],
          title: "Home"
        }
      ],
      servicesSidebarDropDownItems: [
        {
          items: [
            { title: "Service", to: "/service" },
            { title: "Service Details", to: "/service-details" }
          ],
          title: "Service",
        },
      ],
      pagesSidebarDropDownItems: [
        {
          items: [
            { title: "Portfolio", to: "/portfolio" },
            { title: "Portfolio Details", to: "/portfolio-details" }
          ],
          title: "Portfolio",
        },
      ],
      blocksSidebarDropDownItems: [
        {
          items: [
            { title: "Team", to: "/team" },
            { title: "Pricing Plan", to: "/pricing-plan" },
            { title: "Testimonial", to: "/testimonial" },
            { title: "Column", to: "/column" },
            { title: "Contact Form", to: "/contact-form" },
            { title: "Video Popup", to: "/video-popup" },
            { title: "Brand", to: "/brand" }
          ],
          title: "Pages",
        },
      ],
      icon: "menu",
      closeIcon: "x",
    }),

    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>
